import { DataBean } from "../DataBean";

export class BudgetList extends DataBean {


    public async getBudgetListForRefund(year:any,idCashDeskAccount:any,idCashDeskAccountCDP:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getBudgetListForRefund_Number_Number_Number_Number", [year,idCashDeskAccount,idCashDeskAccountCDP,idEmployee]);
    }

}